import React, { useContext, useMemo, useCallback } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Card, Tag, Tooltip } from '@blueprintjs/core'
import { BoxClass } from '../../../helper/classes'
import { GlobalContext, globalOnDemandVars } from '../../../helper/context'
import * as firebase from 'firebase'
import { OverlayProps } from '../../../helper/configs'
import LevelTag, { getLevel } from '../../commonInterface/levelTag'
import level2 from '../../../../assets/images/level2.png'
import { useTranslation } from 'react-i18next'

function InformationAddOn () {
  const { t } = useTranslation()
  const context = useContext(GlobalContext)
  const userData = useMemo(() => (context.configReady ? globalOnDemandVars.userData() : null), [context.configReady])
  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'userData 보기',
      value: userData // , important: true
    })
  }
  const level = useMemo(() => (getLevel(globalOnDemandVars.totalSynapses(), globalOnDemandVars.memorizeRunRecord().length, globalOnDemandVars.memorizeCompleteRecord().length)), [])

  const onSignOut = useCallback(
    () => {
      firebase.auth().signOut().then(() => { location.reload() })
    },
    []
  )
  return useMemo(() => (!context.configReady ? null
    : (<div css={css`text-align: center;`}>
      {userData.isAnonymous ? null : (
        <div>
          <Card css={css`border-radius: 60px; width: 80px; height: 80px; margin: auto; margin-top: 10px; background-image: url(${level2}); background-size: cover;`} />
          {/* <LevelTag level={level} /> */}
        </div>
      )}
      <br />
      {/* <span>You Signed-in as</span> <br /> */}
      <Tag minimal large>{userData.isAnonymous ? 'ANONYMOUS' : `${(userData.email || userData.providerData[0].email || userData.providerData[0].displayName)}`}</Tag>
      {/* <br /> */}
      {userData.isAnonymous ? (<div>
        <br />
        <Tooltip {...OverlayProps}><Button minimal icon={'new-person'} text={t('Go to Sign Up')} onClick={() => {
          globalOnDemandVars.set_forceSignInPage(true)
        }} /></Tooltip>
        <br />
        <Tooltip {...OverlayProps} content={'When you want to sign in as another account or when you would like to abandon the current data'}>
          <Button text={t('Sign In')} minimal onClick={onSignOut} />
        </Tooltip>
      </div>) : (<div css={css`margin-top: 4px;`}>
        <Button icon={'log-out'} text={t('Sign Out')} minimal onClick={onSignOut} />
      </div>)}
    </div>)
  )
  , [context.configReady, onSignOut, userData.email, userData.isAnonymous, userData.providerData])
}

const InformationAddOnBoxClass = new BoxClass(InformationAddOn, 'Account', null, 3, { order: 1, defaultOpen: true })

export default InformationAddOnBoxClass

export { InformationAddOn }
